<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1" stepTitle="价格与套餐"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">预订设置</span>
            </a-col>
          </a-row>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                        :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol"
          >
            <a-form-model-item label="预订数量限制" style="margin-bottom:0;">
              <a-form-model-item style="display:inline-block;" prop="optionMinTotal">
                <a-input v-model.number="ruleForm.optionMinTotal" placeholder="请输入" addon-before="每笔订单最少购买"
                         suffix="份"/>
              </a-form-model-item>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <a-form-model-item style="display:inline-block;">
                <a-input v-model.number="ruleForm.optionMaxTotal" placeholder="请输入" addon-before="最多购买"
                         suffix="份"/>
              </a-form-model-item>
            </a-form-model-item>
            <a-form-model-item label="联系人信息">
              <LinkmanItem ref="linkMan" :contractMessage="ruleForm.optionContractInfo"
                           :requiredList="ruleForm.optionMustContractInfo"
                           @change="changeLinkMan"
              ></LinkmanItem>
            </a-form-model-item>
            <a-form-model-item label="游客信息">
              <TouristItem :isPlayName="ruleForm.optionIsPlayName"
                           :optionTouristSelct="ruleForm.optionTouristinformation"
                           @change="getIsPlayName" @selectChange="getSelectTourist"
              ></TouristItem>
            </a-form-model-item>
            <a-form-model-item label="订单取消时间" prop="optionOrderPlayDate">
              <a-input v-model.number="ruleForm.optionOrderPlayDate" style="max-width:700px;" placeholder="请输入"
                       suffix="分钟后不支付自动取消 建议30分钟"/>
            </a-form-model-item>
            <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
              <a-button type="primary" :disabled="proSource!=0" @click="onSubmit" :loading="submitLoading">
                提交并下一步
              </a-button>
              <a-button v-if="ruleForm.optionId!=0" @click="goEvent" style="margin-left: 10px">下一步</a-button>
            </a-form-model-item>
          </a-form-model>
        </a-card>
        <!-- 产品发布按钮 -->
        <PublishPro></PublishPro>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import TouristItem from '../components/TouristItem'
import LinkmanItem from '../components/LinkmanItem'
import PublishPro from '../components/PublishPro'

export default {
  name: 'PresellBookSet',
  components: {
    ProductHeader,
    PublishHelper,
    TouristItem,
    LinkmanItem,
    PublishPro
  },
  mixins: [ruleFormMixins],
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      optionId: 0,
      ruleForm: {
        optionContractInfo: '',
        optionTouristinformation: [],
        optionMinTotal: 1,
        optionMaxTotal: '',
        optionMustContractInfo: '',
        optionIsPlayName: 0,
        optionOrderPlayDate: 30,
        proId: this.$route.query.proId, //产品ID
        optionId: 0
      },
      bedTypeList: [],
      hotelBindBeds: [],
      submitLoading: false,
      submitFormData: '',
      rules: {
        optionMinTotal: [
          { type: 'number', min: 1, max: 99, message: '请输入1-99的数字', trigger: 'blur' },
          { pattern: /^[+]{0,1}(\d+)$/, message: '请输入正确的数字', trigger: 'blur' }
        ],
        optionOrderPlayDate: [
          { required: true, message: '请输入订单取消时间', trigger: 'blur' },
          { type: 'number', min: 0, max: 120, message: '请输入0-120之间的数字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getBookInfo()
  },
  methods: {
    getIsPlayName(data) {
      this.getLogUtils().logWithTag('getIsPlayName', data)
      this.ruleForm.optionIsPlayName = data
    },
    getSelectTourist(data) {
      this.getLogUtils().logWithTag('getSelectTourist', data)
      this.ruleForm.optionTouristinformation = data
    },
    changeLinkMan(data) {
      this.getLogUtils().logWithTag('changeLinkMan', data)
      this.ruleForm.optionContractInfo = data.str
      this.ruleForm.optionMustContractInfo = data.requiredStr
    },
    checkForm() {
      if (this.ruleForm.optionIsPlayName != 0) {
        if (this.ruleForm.optionTouristinformation && this.ruleForm.optionTouristinformation.length < 1) {
          this.$message.error('请选择游客信息证件')
          return false
        }
      }
      return true
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitData()
          }
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('submitData', this.submitFormData)
      this.submitFormData.optionMaxTotal = this.submitFormData.optionMaxTotal ? this.submitFormData.optionMaxTotal : 1000
      this.submitFormData.optionTouristinformation = this.submitFormData.optionTouristinformation.join(',')
      this.getHttpServices().getProService().post('product/presale/saveOrUpdatePreSaleType', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('预订设置保存成功')
        this.ruleForm.optionId = res
        setTimeout(() => {
          this.goEvent()
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getBookInfo() {
      this.getHttpServices().getProService().get('product/presale/getPreSaleTypeByProId/' + this.proId).then(res => {
        this.getLogUtils().logWithTag('getBookInfo', res)
        this.ruleForm.optionMinTotal = res.optionMinTotal ? res.optionMinTotal : 1
        this.ruleForm.optionContractInfo = res.optionContractInfo ? res.optionContractInfo : ''
        this.ruleForm.optionMustContractInfo = res.optionMustContractInfo ? res.optionMustContractInfo : ''
        this.ruleForm.optionTouristinformation = res.optionTouristinformation ? res.optionTouristinformation.split(',') : []
        this.ruleForm.optionId = res.optionId ? res.optionId : 0
        this.optionId = res.optionId ? res.optionId : 0
        this.ruleForm.optionOrderPlayDate = res.optionOrderPlayDate ? res.optionOrderPlayDate : ''
        this.ruleForm.optionMaxTotal = res.optionMaxTotal ? res.optionMaxTotal : ''
        this.ruleForm.optionIsPlayName = res.optionIsPlayName ? res.optionIsPlayName : 0
        // 子组件传值
        this.$refs.linkMan.getLinkInfo(this.ruleForm.optionContractInfo, this.ruleForm.optionMustContractInfo)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goEvent() {
      this.$router.push({
        name: 'PresellPriceSet',
        query: {
          proId: this.proId,
          catalogId: this.catalogId,
          proSource: this.proSource,
          optionIdSet: this.ruleForm.optionId
        }
      })
    }
  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>